import { Dispatch } from 'redux'
import { connect } from 'react-redux'

import GotIt, { IStateProps, IDispatchProps, IOwnProps } from './GotIt'

import { IStoreState } from '../../services/store/IStoreState'
import {
    DashboardAction,
    requestOrderGotIt,
} from '../../services/store/actions/dashboard/DashboardAction'

function mapStateToProps(): IStateProps {
    return {}
}

function mapDispatchToProps(
    dispatch: Dispatch<DashboardAction>
): IDispatchProps {
    return {
        requestGotIt: (orderId, itemId, customWay, onEnd) =>
            dispatch(requestOrderGotIt({ orderId, itemId, customWay, onEnd })),
    }
}

export default connect<IStateProps, IDispatchProps, IOwnProps, IStoreState>(
    mapStateToProps,
    mapDispatchToProps
)(GotIt)
